// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__296it","question":"styles_question__2M-75","description":"styles_description__9VtWB"};